<aside class="sidebar" role="navigation" aria-label="Knowledge categories">
  <div class="sidebar-scroll">
    <div *ngFor="let category of filteredCategoryListBizagiData; trackBy: trackByCategory" class="category">
      <button class="category-header" (click)="toggleCategory(category)" [attr.aria-expanded]="category.Expanded" [attr.aria-controls]="'cat-'+category.DisplayName">
        <span class="category-name">{{ category.DisplayName | uppercase }}</span>
        <bzg-icon [nameIcon]="category.Expanded ? 'icon-arrow-up-table' : 'icon-arrow-down-table'" [size]="16"></bzg-icon>
      </button>
      <ul *ngIf="category.Expanded" [id]="'cat-'+category.DisplayName" class="items-list">
        <li *ngFor="let item of getSortedKBBizagiData(category); trackBy: trackByItem" class="sidebar-item" [class.active]="selectedItem === item" (click)="selectItem(item)">
          <div class="item-row">
            <span class="item-title bk-bizagi__item-title">
              <bzg-icon [ngClass]="{'icon-learned-green': selectedItem === item, 'icon-gray': selectedItem !== item}" [nameIcon]="'icon-bizagi-data'" [size]="14"></bzg-icon>
              <span class="item-display-name">{{ item.DisplayName }}</span>
            </span>
          </div>
          <div class="item-info">
            <span class="start-date"><strong>{{ 'BASEKNOWLEDGECATALOG.TABLE.START_DATE' | translate }}:</strong> {{ item.StartDate | showDateFormat: 2 }}</span>
            <span>{{ getFrecuencyTranslated(item.Frequency) }}</span>
          </div>
        </li>
        <li *ngIf="!category.KBLearned.length" class="empty">{{ 'BASEKNOWLEDGECATALOG.NO_ARTIFACTS' | translate }}</li>
      </ul>
    </div>
    <div *ngIf="!filteredCategoryListBizagiData.length" class="empty">
      {{ 'BASEKNOWLEDGECATALOG.NO_ELEMENTS' | translate }}
    </div>
  </div>
</aside>